/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto } from '../models/Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MyHoldingsOverviewService {

    /**
     * @param participantId
     * @returns Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppMyHoldingsOverviewHoldingsForAdmin(
        participantId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_MyHoldingsOverviewDto_MyHoldingsOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/my-holdings-overview/holdings-for-admin/{ParticipantId}',
            path: {
                'ParticipantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
